/* eslint-disable @typescript-eslint/unbound-method, @typescript-eslint/no-misused-promises */
import { useEffect, useRef, useState } from 'react'
import Player from '@vimeo/player'

import Modal from '../../units/Modal'
import * as styles from './styles'

type CinemaProps = { show: boolean; onHide?: () => void; videoId?: string }

const Cinema = ({ show, onHide, videoId = '372928980' }: CinemaProps) => {
  const video = useRef(null)
  const player = useRef(null)
  const [fadeIn, setFadeIn] = useState(false)
  const [timePercentage, setTimePercentage] = useState(0)

  const FADE_MS = 400

  const closePlayer = cb => {
    return new Promise(resolve => {
      setFadeIn(false)
      setTimeout(resolve, FADE_MS)
    }).then(cb)
  }

  useEffect(() => {
    if (!video.current) return

    const id = Number.parseInt(videoId)

    if (Number.isNaN(id)) {
      return
    }

    player.current = new Player(video.current, {
      id,
      width: 1920,
      height: 1080,
    })

    setFadeIn(true)

    player.current
      .play()
      .then(() => {
        // success
      })
      .catch(() => {
        // catch interrupt by call to pause
      })

    return () => {
      player.current.off('play')
    }
  }, [show])

  useEffect(() => {
    if (!player.current) return
    player.current.on('timeupdate', ({ percent }) => setTimePercentage(percent))
  }, [show])

  return (
    <Modal show={show} onHide={onHide} noWrapper>
      <styles.Cinema fadeIn={fadeIn} fadeDelay={FADE_MS}>
        <styles.CloseButton onClick={() => closePlayer(onHide)}>
          <styles.Icon />
        </styles.CloseButton>
        <styles.VideoWrapper ref={video}>
          <styles.ProgressBarWrap>
            <styles.ProgressBar
              style={{
                transform: `translateX(${(timePercentage - 1) * 100}%)`,
              }}
            />
          </styles.ProgressBarWrap>
        </styles.VideoWrapper>
      </styles.Cinema>
    </Modal>
  )
}

export default Cinema
